(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[399],{

/***/ 87654:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-finance/[slug]",
      function () {
        return __webpack_require__(42257);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* reexport safe */ _cinch_nx_landing_feature_seo_pages__WEBPACK_IMPORTED_MODULE_0__.Yg; }
/* harmony export */ });
/* harmony import */ var _cinch_nx_landing_feature_seo_pages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38240);
var __N_SSG = true;



/***/ }),

/***/ 38240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yg": function() { return /* reexport */ SEOPageFeature; }
});

// UNUSED EXPORTS: getStaticPathsGenerator, getStaticPropsGenerator, storyblokLinkToPath

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/search/shared/src/index.ts + 103 modules
var src = __webpack_require__(69579);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 266 modules
var shared_src = __webpack_require__(2388);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 54 modules
var ui_src = __webpack_require__(83624);
// EXTERNAL MODULE: ../../../libs/landing/feature-seo-pages/src/lib/components/latest-cars-section/latest-cars-section.module.css
var latest_cars_section_module = __webpack_require__(46136);
var latest_cars_section_module_default = /*#__PURE__*/__webpack_require__.n(latest_cars_section_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/lib/components/latest-cars-section/latest-cars-section.tsx







const LatestCarsSection = ({ tags , fuelType , seats , colour , bodyType , numberOfVehicles  })=>{
    const { data , countOfData , browseButtonUrl , error  } = (0,shared_src/* useLatestVehicles */.Kk)({
        tags: tags,
        fuelType: fuelType,
        bodyType: bodyType,
        seats: seats,
        colour: colour,
        numberOfVehicles: numberOfVehicles,
        caller: "seo-pages"
    });
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    if (!data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
    if (error) {
        console.log(error);
        return null;
    }
    if (data.vehicleListings.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (latest_cars_section_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (latest_cars_section_module_default()).cardContainer,
                    children: data.vehicleListings.map((vehicle)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* VehicleCard */.Ur, {
                            id: vehicle.vehicleId,
                            vehicle: vehicle,
                            isAvailable: vehicle.isAvailable,
                            isSaved: false,
                            isPending: false,
                            discountInPence: vehicle.discountInPence,
                            showActions: false,
                            onCardClick: ()=>{
                                trackEvent({
                                    eventName: `SEO pages - View fpa card click`,
                                    data: {
                                        event: {
                                            name: "click",
                                            category: "button",
                                            label: `seo_view_fpa_card`,
                                            value: vehicle
                                        }
                                    },
                                    type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE
                                });
                            }
                        }, vehicle.vehicleId))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (latest_cars_section_module_default()).buttonWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Primary */.sq, {
                        element: "a",
                        href: browseButtonUrl,
                        onClick: ()=>{
                            trackEvent({
                                eventName: `SEO pages - Browse cars click`,
                                data: {
                                    event: {
                                        name: "click",
                                        category: "button",
                                        label: `Browse cars button on SEO pages`
                                    }
                                },
                                type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE
                            });
                        },
                        classNames: {
                            button: (latest_cars_section_module_default()).browseCarsButton
                        },
                        children: [
                            "Browse ",
                            countOfData ? countOfData : "all",
                            " cars"
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-seo-pages/src/lib/components/links-section/links-section.module.css
var links_section_module = __webpack_require__(92418);
var links_section_module_default = /*#__PURE__*/__webpack_require__.n(links_section_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/lib/components/links-section/links-section.tsx



const LinksSection = ({ title , links  })=>{
    const models = links === null || links === void 0 ? void 0 : links.map((p)=>({
            url: p.url.url,
            text: p.text
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (links_section_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* LinkList */.Mc, {
            title: title,
            linkItems: models
        })
    });
};

// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../libs/landing/feature-seo-pages/src/lib/components/text-inline-image/text-inline-image.module.css
var text_inline_image_module = __webpack_require__(87260);
var text_inline_image_module_default = /*#__PURE__*/__webpack_require__.n(text_inline_image_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/lib/components/text-inline-image/text-inline-image.tsx






const TextInlineImage = ({ body , image , imagePosition ="right"  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((text_inline_image_module_default()).wrapper, {
            [(text_inline_image_module_default()).imageLeft]: imagePosition === "left"
        }),
        "data-testid": "text-inline-image-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (text_inline_image_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,storyblok_src/* getStoryblokImageServiceUrl */.Vb)(image.filename, {
                        width: 900,
                        filters: [
                            {
                                quality: 60
                            }
                        ]
                    }),
                    className: (text_inline_image_module_default()).image,
                    alt: image.alt ?? undefined
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                classNames: {
                    body: "storyblokRichTextBody"
                },
                children: (0,shared_src/* renderWithResolver */.be)(body)
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/design-system/components/icons/src/index.ts + 266 modules
var icons_src = __webpack_require__(39957);
// EXTERNAL MODULE: ../../../libs/landing/feature-seo-pages/src/lib/components/seo-table/seo-table.module.css
var seo_table_module = __webpack_require__(75501);
var seo_table_module_default = /*#__PURE__*/__webpack_require__.n(seo_table_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/lib/components/seo-table/seo-table.tsx



function renderBody(body) {
    if (body.includes("*check-tick-icon*")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.CheckTickIcon, {
                    size: 24
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: body.replace("*check-tick-icon*", "")
                })
            ]
        });
    } else if (body.includes("*cross-icon*")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.CrossIcon, {
                    size: 24
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: body.replace("*cross-icon*", "")
                })
            ]
        });
    } else {
        return body;
    }
}
const SEOTable = ({ heading , table  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (seo_table_module_default()).heading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (seo_table_module_default()).scroll,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    className: (seo_table_module_default()).table,
                    "aria-label": heading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: table.thead.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        "aria-label": heading.value,
                                        children: heading.value
                                    }, heading._uid))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: table.tbody.filter((row)=>!!row.body[0].value).map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                    children: row.body.map((cell)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            "aria-label": cell.value.toString(),
                                            children: renderBody(cell.value.toString())
                                        }, cell._uid))
                                }, row._uid))
                        })
                    ]
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/lib/components/index.ts





;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/lib/data/storyblok-renderer-map.tsx






const storyblokComponents = {
    FaqSection: shared_src/* FaqAccordion */.eo,
    YoutubeVideo: shared_src/* Video */.nk,
    LatestCarsSection: LatestCarsSection,
    RichTextSection: shared_src/* RichTextSection */.nT,
    FeatureSection: shared_src/* FeatureSection */.gT,
    LinksSection: LinksSection,
    TextInlineImage: TextInlineImage,
    Image: shared_src/* ImageObject */.IZ,
    TableSection: SEOTable
};

// EXTERNAL MODULE: ../../../libs/landing/feature-seo-pages/src/lib/seo-page.module.css
var seo_page_module = __webpack_require__(31228);
var seo_page_module_default = /*#__PURE__*/__webpack_require__.n(seo_page_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/lib/seo-page.tsx









const SEOPageFeature = ({ story  })=>{
    var ref;
    const content = {
        ...story === null || story === void 0 ? void 0 : story.content
    };
    const typedContent = content;
    const SEO = typedContent === null || typedContent === void 0 ? void 0 : (ref = typedContent["SEO"]) === null || ref === void 0 ? void 0 : ref[0];
    const { vehicleCount  } = (0,src/* useVehicleCount */.qU)();
    const router = (0,next_router.useRouter)();
    const numberOfCars = new Intl.NumberFormat("en-GB").format(vehicleCount ?? 0);
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Abandoned Landing page - click search all cars button`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "button",
                    label: "browse all cars",
                    action: "footer"
                }
            }
        });
        router.push("/used-cars");
    };
    const limitedItems = {
        FaqSection: 1
    };
    const wrappedComponents = typedContent.body.map((el)=>el.component).filter((el)=>el !== "FeatureSection");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                fallbackTitle: (story === null || story === void 0 ? void 0 : story.slug) ? story === null || story === void 0 ? void 0 : story.slug : "Cinch Used Cars Article",
                fallbackDescription: "Cinch Used Cars"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (seo_page_module_default()).mainSection,
                "data-testid": "seo-page",
                children: [
                    typedContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                        block: typedContent.body,
                        limitedItems: limitedItems,
                        componentsWithWrapper: wrappedComponents,
                        components: storyblokComponents
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* FullWidthCTA */.S3, {
                        iconName: "search",
                        iconGradient: "galaxy",
                        iconSize: 41,
                        title: "Let’s find your next car",
                        subtitle: "Ready to hit the open road?",
                        buttonLabel: `Search all ${numberOfCars} cars`,
                        className: (seo_page_module_default()).cta,
                        onButtonClick: handleClick,
                        img: {
                            src: "https://a.storyblok.com/f/132543/1054x407/a30d43e649/about-us-civic.png/m/871x0",
                            alt: "Side view of a Honda Civic",
                            width: 871,
                            height: 336
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/lib/get-static-props.ts
// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if

const getStaticPropsGenerator = (path)=>{
    return async ({ params , preview =false  })=>{
        try {
            var ref;
            const slug = params ? params === null || params === void 0 ? void 0 : params["slug"] : "index";
            const story = await getStoryBySlug(`${path}/${slug}`, {
                version: preview ? "draft" : "published",
                cv: Date.now()
            });
            if (!story) {
                throw new Error("Seo page failed to get story");
            }
            const HeroProps = (ref = story.content) === null || ref === void 0 ? void 0 : ref.hero[0];
            return {
                props: {
                    story,
                    preview,
                    layoutProps: {
                        heroProps: HeroProps,
                        showBorderRadius: true,
                        showFooterBorderRadius: false
                    }
                },
                revalidate: 60
            };
        } catch (error) {
            console.log(error);
            return {
                notFound: true,
                props: {
                    story: null,
                    preview,
                    layoutProps: {
                        heroProps: {},
                        showBorderRadius: true,
                        showFooterBorderRadius: false
                    }
                },
                revalidate: 60
            };
        }
    };
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/lib/get-static-paths.ts


const getStaticPathsGenerator = (slug)=>async ()=>{
        try {
            const links = await getLinks(slug);
            const paths = storyblokLinkToPath({
                links
            });
            return {
                paths,
                fallback: "blocking"
            };
        } catch  {
            return {
                paths: [],
                fallback: "blocking"
            };
        }
    };

;// CONCATENATED MODULE: ../../../libs/landing/feature-seo-pages/src/index.ts






/***/ }),

/***/ 46136:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"latest-cars-section_wrapper__u_fMZ","cardContainer":"latest-cars-section_cardContainer__LvPFA","title":"latest-cars-section_title__d0kmf","browseCarsButton":"latest-cars-section_browseCarsButton__msiPR","buttonWrapper":"latest-cars-section_buttonWrapper__egV6x"};

/***/ }),

/***/ 92418:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"links-section_container__LP5jh","sectionTitle":"links-section_sectionTitle___j2D4"};

/***/ }),

/***/ 75501:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scroll":"seo-table_scroll___Wpuo","heading":"seo-table_heading__IRoQj","table":"seo-table_table__gOYTG"};

/***/ }),

/***/ 87260:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"text-inline-image_wrapper__Zr_45","imageLeft":"text-inline-image_imageLeft__rGn5k","imageWrapper":"text-inline-image_imageWrapper__s_agM","image":"text-inline-image_image___Hxgd"};

/***/ }),

/***/ 31228:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"seo-page_mainSection__G1FBq","cta":"seo-page_cta__F8_Wa"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9661,9579,9774,2888,179], function() { return __webpack_exec__(87654); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);